import React from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import createBrowserHistory from 'history/createBrowserHistory'
import { PaySafelyInvoice } from './routes/paySafely/invoice/components'
import { NotFound } from './components/notFound'
import MainLayout from './base/layout/mainLayout'

const history = createBrowserHistory({
  basename: ''
})

export const routes = () => (
  <Router history={history}>
    <Switch>
      <Route path="/">
        <MainLayout>
          <Switch>
            <Route path="/:token" component={PaySafelyInvoice} />
            <Route path="/" component={PaySafelyInvoice} />
          </Switch>
        </MainLayout>
      </Route>
      <Route path="/*" component={NotFound} />
    </Switch>
  </Router>
)



// WEBPACK FOOTER //
// ./src/routes.jsx